const remoteModalNameId = 'remoteModal';
const localModalNameId = 'localModal';

const getOrCreateRemoteModalHtml = () => {
    const root = document;
    let element = root.querySelector(`#${remoteModalNameId}`);
    if (!element) {
        element = document.createElement('div');
        element.id = remoteModalNameId;
        element.className = 'modal';
        element.innerHTML = `
            <div class="modal-background"></div>
            <div class="remote-content" style="z-index:40"></div>
        `;

        root.body ? root.body.appendChild(element) : root.appendChild(element);
    }

    return element;
}

const getorCreateLocalModalHtml = () => {
    const root = document;
    let element = root.querySelector(`#${localModalNameId}`);
    if (!element) {
        element = document.createElement('div');
        element.id = localModalNameId;
        element.className = 'modal';
        element.innerHTML = `
            <div class="modal-background"></div>
            <div class="local-content" style="z-index:40"></div>
        `;

        root.body ? root.body.appendChild(element) : root.appendChild(element);
    }

    return element;
}


var remoteModalHandler = (contentSwapSelector = "#mainContent", pushStory = true) => {
    const root = document.querySelector(contentSwapSelector);
    if (!root) {
        return;
    }
    const triggers = root.querySelectorAll('.ajax-modal') || [];

    getOrCreateRemoteModalHtml();

    const closeRemoteListen = () => {
        (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .cancel') || []).forEach(($close) => {
            const $target = $close.closest('.modal');

            // Remove any existing click handlers before adding new ones
            $close.removeEventListener('click', closeRemoteModalHandler);
            $close.addEventListener('click', closeRemoteModalHandler);

            function closeRemoteModalHandler() {
                closeRemoteModal($target);
            }
        });
    };

    const closeRemoteModal = ($target) => {
        $target.classList.remove('is-active');

        // htmx ajax request to get the current page with all url params
        let url = window.location.href;
        // add param no-scroll=1 if not present
        if (!url.includes('no-scroll=1')) {
            url += url.includes('?') ? '&no-scroll=1' : '?no-scroll=1';
        }

        htmx.ajax('GET', url, content => {
            htmx.swap(contentSwapSelector, content, { swapStyle: 'innerHTML' });
        });

    };

    const bindLinkEvents = (modalContent) => {
        const links = modalContent.querySelectorAll('a.ajax-link') || [];
        links.forEach(link => {
            link.removeEventListener('click', linkHandler);  // Clean up previous event listener
            link.addEventListener('click', linkHandler);

            async function linkHandler(e) {
                e.preventDefault();

                const url = link.getAttribute('href');
                const response = await fetch(url, {
                    headers: {
                        'Is-Modal': 'true'
                    }
                });

                const html = await response.text();
                modalContent.innerHTML = html;

                closeRemoteListen();
                bulmaSelectWrapper();
                bindSubmitEvents(modalContent);
                bindLinkEvents(modalContent);
            }
        });
    }

    const bindSubmitEvents = (modalContent) => {


        const submitBtn = modalContent.querySelectorAll('button[type="submit"]') || [];
        submitBtn.forEach(btn => {
            btn.removeEventListener('click', submitHandler);  // Clean up previous event listener
            btn.addEventListener('click', submitHandler);
            btn.closest('.modal').querySelector('form').addEventListener('submit', submitHandler);

            async function submitHandler(e) {
                e.preventDefault();

                const form = modalContent.querySelector('form');
                const formData = new FormData(form);
                // get url from form action attribute
                const formUrl = form.getAttribute('action');

                const response = await fetch(formUrl, {
                    method: form.method,
                    body: formData,
                    headers: {
                        'Is-Modal': 'true'
                    }
                });

                // if responses redirect to a new page, trigger htmx to redirect
                if (response.redirected) {
                    const modalDiv = modalContent.closest('.modal');
                    modalDiv.classList.remove('is-active');

                    const html = await response.text();
                    htmx.swap(contentSwapSelector, html, { swapStyle: 'innerHTML' });
                    // change the path
                    if (pushStory) {
                        window.history.pushState({}, '', response.url);
                    }
                    return;
                }

                const html = await response.text();
                modalContent.innerHTML = html;

                closeRemoteListen();
                bulmaSelectWrapper();
                bindSubmitEvents(modalContent);
                bindLinkEvents(modalContent);
            }
        });
    };

    triggers.forEach(trigger => {
        trigger.addEventListener('click', async (e) => {
            e.preventDefault();

            let modal = getOrCreateRemoteModalHtml();
            const modalContent = modal.querySelector('.remote-content');
            modalContent.innerHTML = 'Loading...';

            modal.classList.add('is-active');

            const url = trigger.dataset.url;
            const response = await fetch(url, {
                headers: {
                    'Is-Modal': 'true'
                }
            });
            const html = await response.text();
            modalContent.innerHTML = html;

            closeRemoteListen();
            bulmaSelectWrapper();
            bindSubmitEvents(modalContent);  // Bind submit event after content load
            bindLinkEvents(modalContent);  // Bind link event after content load
        });
    });
};


var localModalHandler = (contentSwapSelector = "#mainContent") => {
    const root = document.querySelector(contentSwapSelector);
    if (!root) {
        return;
    }
    let localModal = getorCreateLocalModalHtml();

    // Functions to open and close a modal
    function openModal() {
        localModal.classList.add('is-active');
    }

    function closeModal() {
        localModal.classList.remove('is-active');
    }

    // Add a click event on buttons to open a specific modal
    (root.querySelectorAll('.modal-trigger') || []).forEach(($trigger) => {
        const modal = $trigger.dataset.target;

        $trigger.addEventListener('click', () => {
            let $target = localModal.querySelector('.local-content');
            $target.innerHTML = root.querySelector(modal).innerHTML;

            (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
                const $target = $close.closest('.modal');

                $close.addEventListener('click', () => {
                    closeModal($target);
                });
            });

            openModal();
        });
    });

    // Add a keyboard event to close all modals
    document.addEventListener('keydown', (event) => {
        if (event.key === "Escape") {
            closeModal();
        }
    });

};